export const getViewportWidth = (): number => {
    const isBrowserSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
    );
    return isBrowserSafari
        ? document.documentElement.clientWidth
        : window.innerWidth;
};
